<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="data"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            class="table__top-header"
          >
            <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.machine') }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="8"
            class="table__top-tools"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$vuetify.lang.t('$vuetify.search')"
              single-line
              hide-details
              dense
              style="max-width: 250px;"
            />
            <download-group>
              <download
                format="csv"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['id', 'factor', 'identifier', 'name', 'tag', 'unit']
                  ),
                  [
                    {id: 'id'},
                    {identifier: $vuetify.lang.t('$vuetify.identifier')},
                    {name: $vuetify.lang.t('$vuetify.name')},
                    {unit: $vuetify.lang.t('$vuetify.unit')},
                    {factor: $vuetify.lang.t('$vuetify.factor')},
                    {tag: $vuetify.lang.t('$vuetify.tag')}
                  ]
                )"
                text="csv"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-delimited
                </v-icon>
              </download>
              <download
                format="xls"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['id', 'factor', 'identifier', 'name', 'tag', 'unit']
                  ),
                  [
                    {id: 'id'},
                    {identifier: $vuetify.lang.t('$vuetify.identifier')},
                    {name: $vuetify.lang.t('$vuetify.name')},
                    {unit: $vuetify.lang.t('$vuetify.unit')},
                    {factor: $vuetify.lang.t('$vuetify.factor')},
                    {tag: $vuetify.lang.t('$vuetify.tag')}
                  ]
                )"
                text="xls"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-excel
                </v-icon>
              </download>
            </download-group>
            <v-dialog
              v-model="deleteDialog"
              persistent
            >
              <v-card>
                <v-card-title class="headline">
                  {{ $vuetify.lang.t('$vuetify.generalDeleteMessage') }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="deleteDialog = false"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="deleteAction"
                  >
                    {{ $vuetify.lang.t('$vuetify.delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog"
              persistent
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                >
                  {{ $vuetify.lang.t('$vuetify.newItem') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.identifier"
                          :label="$vuetify.lang.t('$vuetify.identifier')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          :label="$vuetify.lang.t('$vuetify.name')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.unit"
                          :label="$vuetify.lang.t('$vuetify.unit')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.factor"
                          :label="$vuetify.lang.t('$vuetify.factor')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.tag"
                          :label="$vuetify.lang.t('$vuetify.tag')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1" />
                  <v-btn
                    color="secondary"
                    text
                    @click="close"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    text
                    @click="save"
                  >
                    {{ $vuetify.lang.t('$vuetify.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import apiUtil from '../utils/ApiUtil';
import filterUtil from '../utils/FilterUtil';
import remapperUtil from '../utils/RemapperUtil';
import DownloadComponent from './DownloadComponent.vue';
import DownloadGroupComponent from './DownloadGroupComponent.vue';

export default {
  components: {
    download: DownloadComponent,
    downloadGroup: DownloadGroupComponent,
  },
  data: () => {
    return {
      permissionsKey: 2,
      search: '',
      dialog: false,
      deleteDialog: false,
      deletedItem: {},
      data: [],
      editedIndex: -1,
      editedItem: {
        identifier: '',
        name: '',
        unit: '',
        factor: 0,
        tag: '',
      },
      defaultItem: {
        identifier: '',
        name: '',
        unit: '',
        factor: 0,
        tag: '',
      },
      filterUtil,
      remapperUtil,
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.newItem') : this.$vuetify.lang.t('$vuetify.editItem');
    },
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$vuetify.lang.t('$vuetify.identifier'), value: 'identifier' },
        { text: this.$vuetify.lang.t('$vuetify.name'), value: 'name' },
        { text: this.$vuetify.lang.t('$vuetify.unit'), value: 'unit' },
        { text: this.$vuetify.lang.t('$vuetify.factor'), value: 'factor' },
        { text: this.$vuetify.lang.t('$vuetify.tag'), value: 'tag' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllMachines();
      this.data = result;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.data.findIndex((i) => { return i.id === this.editedItem.id; });
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async deleteAction() {
      const index = this.data.findIndex((i) => { return i.id === this.deletedItem.id; });
      const result = await apiUtil.deleteMachineById(this.deletedItem);
      if (result) {
        this.data.splice(index, 1);
      }
      this.deleteDialog = false;
    },
    async save() {
      const response = await apiUtil.saveMachine(this.editedItem);
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], this.editedItem);
      } else {
        this.data.push(response);
      }

      this.close();
    },
  },
};
</script>
